"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialMultiSelectState = {
    showOptions: false,
    selectedOptions: [],
    enabledOptions: [],
    availableOptions: [],
    allSelected: false,
    canApply: false,
    searchTerm: "",
    searchResults: [],
    showSelected: false,
};
function multiselectReducer(state, action) {
    switch (action.type) {
        case "setShowOptions":
            return __assign(__assign({}, state), { showOptions: action.payload });
        case "setAllSelected":
            return __assign(__assign({}, state), { allSelected: action.payload });
        case "setCanApply":
            return __assign(__assign({}, state), { canApply: action.payload });
        case "closeDropdown":
            return __assign(__assign({}, state), { enabledOptions: [], allSelected: false, searchTerm: "", showOptions: false });
        case "applySelection":
            return __assign(__assign({}, state), { selectedOptions: action.payload, searchTerm: "", showOptions: false });
        case "setEnabledOptions":
            return __assign(__assign({}, state), { enabledOptions: action.payload.enabledOptions, allSelected: action.payload.allSelected });
        case "clearSelection":
            return __assign(__assign({}, state), { enabledOptions: [], allSelected: false });
        case "resetSelection":
            return __assign(__assign({}, state), { enabledOptions: [], allSelected: true });
        case "setSearchTerm":
            return __assign(__assign({}, state), { searchTerm: action.payload });
        case "applySearch":
            return __assign(__assign({}, state), { availableOptions: action.payload.searchResults, searchResults: action.payload.searchResults });
        case "setShowSelected":
            return __assign(__assign({}, state), { searchResults: action.payload, searchTerm: "", showSelected: true });
        case "setShowAll":
            return __assign(__assign({}, state), { searchResults: action.payload, searchTerm: "", showSelected: false });
        case "abandonChanges":
            return __assign(__assign({}, state), { enabledOptions: action.payload, showOptions: false, showSelected: false });
        case "reset":
            return __assign(__assign({}, exports.initialMultiSelectState), { selectedOptions: action.payload });
        case "setSelectedOptions":
            return __assign(__assign({}, state), { selectedOptions: action.payload });
        default:
            throw new Error();
    }
}
exports.multiselectReducer = multiselectReducer;
